import { CreateTimerResponseType } from '../../types/CreateTimerResponse'

export const CreateTimerResponse: CreateTimerResponseType = {
  timerState: 'work',
  endTimestamp: 1648230434032,
  stopTime: 10,
  workTime: 25,
  breakTime: 15
}
